module.exports = __webpack_public_path__ + "media/src/images/top_covers/2021_jan_04-eccef319c4b2db2096925269f8b85cd3.png";